import { Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import { useMemo } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function N() {
    const { useLang, useRouter, Link, useState, useEffect } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const { locale } = useRouter();
    const [active, setActive] = useState(0);
    const tabs: any = [t('secN_tab1'), t('secN_tab2'), t('secN_tab3')];
    if (locale === 'au') {
        tabs.push(t('secN_tab4'));
    }
    const [gap, setGap] = useState(24);
    // 本地化博客blog
    const LOCAL_SITES: string[] = ['za', 'es', 'it', 'uk', 'au'];
    const EU_SITES: string[] = ['de', 'fr', 'eu', 'cis'];
    const lists: any = {
        de: [
            {
                img: '/responsive/picture/outdoor-recreation/13_1',
                desc: t('secN_card1_text'),
                link: t('secN_card1_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_2',
                desc: t('secN_card2_text'),
                link: t('secN_card2_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_3',
                desc: t('secN_card3_text'),
                link: t('secN_card3_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_4',
                desc: t('secN_card4_text'),
                link: t('secN_card4_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_5',
                desc: t('secN_card5_text'),
                link: t('secN_card5_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_6',
                desc: t('secN_card6_text'),
                link: t('secN_card6_link'),
            },
        ],
        fr: [
            {
                img: '/responsive/picture/outdoor-recreation/13_1',
                desc: t('secN_card1_text'),
                link: t('secN_card1_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_2',
                desc: t('secN_card2_text'),
                link: t('secN_card2_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_3',
                desc: t('secN_card3_text'),
                link: t('secN_card3_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_4',
                desc: t('secN_card4_text'),
                link: t('secN_card4_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_5',
                desc: t('secN_card5_text'),
                link: t('secN_card5_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_6',
                desc: t('secN_card6_text'),
                link: t('secN_card6_link'),
            },
        ],
        za: {
            0: [
                {
                    img: '/responsive/picture/outdoor-recreation/13_1_1',
                    desc: t('secN_tab1_card1_text'),
                    link: t('secN_tab1_card1_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_1_2',
                    desc: t('secN_tab1_card2_text'),
                    link: t('secN_tab1_card2_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_1_3',
                    desc: t('secN_tab1_card3_text'),
                    link: t('secN_tab1_card3_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_1_4',
                    desc: t('secN_tab1_card4_text'),
                    link: t('secN_tab1_card4_link'),
                },
            ],
            1: [
                {
                    img: '/responsive/picture/outdoor-recreation/13_2_1',
                    desc: t('secN_tab2_card1_text'),
                    link: t('secN_tab2_card1_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_2_2',
                    desc: t('secN_tab2_card2_text'),
                    link: t('secN_tab2_card2_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_2_3',
                    desc: t('secN_tab2_card3_text'),
                    link: t('secN_tab2_card3_link'),
                },
            ],
            2: [
                {
                    img: '/responsive/picture/outdoor-recreation/13_3_1',
                    desc: t('secN_tab3_card1_text'),
                    link: t('secN_tab3_card1_link'),
                },
                // {
                //     img: '/responsive/picture/outdoor-recreation/13_3_2',
                //     desc: t('secN_tab3_card2_text'),
                //     link: t('secN_tab3_card2_link'),
                // },
                // {
                //     img: '/responsive/picture/outdoor-recreation/13_3_3',
                //     desc: t('secN_tab3_card3_text'),
                //     link: t('secN_tab3_card3_link'),
                // },
            ],
        },
        us: {
            0: [
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747996281871/us_1_1.jpg',
                    desc: t('secN_tab1_card1_text'),
                    link: 'https://www.ecoflow.com/us/blog/best-portable-air-conditioners-outdoor-activities',
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747996287288/us_1_2.jpg',
                    desc: t('secN_tab1_card2_text'),
                    link: 'https://www.ecoflow.com/us/blog/best-solar-generator-for-camping',
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747996290007/us_1_3.jpg',
                    desc: t('secN_tab1_card3_text'),
                    link: 'https://www.ecoflow.com/us/blog/top-camping-power-solutions-2025',
                },
                // {
                //     img: '/responsive/picture/outdoor-recreation/13_1_4',
                //     desc: t('secN_tab1_card4_text'),
                //     link: t('secN_tab1_card4_link'),
                // },
            ],
            1: [
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747996625459/us_2_1.jpg',
                    desc: t('secN_tab2_card1_text'),
                    link: 'https://www.ecoflow.com/us/blog/what-are-most-efficient-solar-products-for-home-use',
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747996627866/us_2_2.jpg',
                    desc: t('secN_tab2_card2_text'),
                    link: 'https://www.ecoflow.com/us/blog/camping-in-a-van',
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747996630618/us_2_3.jpg',
                    desc: t('secN_tab2_card3_text'),
                    link: 'https://www.ecoflow.com/us/blog/how-to-host-outdoor-movie-night',
                },
            ],
            2: [
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747996974785/us_3_1.jpg',
                    desc: t('secN_tab3_card1_text'),
                    link: 'https://www.ecoflow.com/us/blog/fishing-in-florida',
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747996977557/us_3_2.jpg',
                    desc: t('secN_tab3_card2_text'),
                    link: 'https://www.ecoflow.com/us/blog/best-solar-panel-for-boats',
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747996980045/us_3_3.jpg',
                    desc: t('secN_tab3_card3_text'),
                    link: 'https://www.ecoflow.com/us/blog/best-solar-generators-for-house-boats',
                },
            ],
        },
        ca: {
            0: [
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747997342758/ca_1_1.jpg',
                    desc: t('secN_tab1_card1_text'),
                    link: 'https://www.ecoflow.com/ca/blog/cpap-battery-camping-breathe-easy-offgrid-with-ecoflow',
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747997345982/ca_1_2.jpg',
                    desc: t('secN_tab1_card2_text'),
                    link: 'https://www.ecoflow.com/ca/blog/free-places-to-camp-in-canada',
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747997348726/ca_1_3.jpg',
                    desc: t('secN_tab1_card3_text'),
                    link: 'https://blog.ecoflow.com/ca/best-portable-power-stations-for-cpap/',
                },
            ],
            1: [
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747997461220/ca_2_1.jpg',
                    desc: t('secN_tab2_card1_text'),
                    link: 'https://www.ecoflow.com/ca/blog/car-camping-101',
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747997464123/ca_2_2.jpg',
                    desc: t('secN_tab2_card2_text'),
                    link: 'https://www.ecoflow.com/ca/blog/rv-accessories',
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1747997466610/ca_2_3.jpg',
                    desc: t('secN_tab2_card3_text'),
                    link: 'https://blog.ecoflow.com/ca/best-solar-generators-for-boats/ ',
                },
            ],
            2: [
                {
                    img: '/responsive/picture/outdoor-recreation/13_3_1.jpg',
                    desc: t('secN_tab3_card1_text'),
                    link: t('secN_tab3_card1_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_3_2.jpg',
                    desc: t('secN_tab3_card2_text'),
                    link: t('secN_tab3_card2_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_3_3.jpg',
                    desc: t('secN_tab3_card3_text'),
                    link: t('secN_tab3_card3_link'),
                },
            ],
        },
        uk: {
            0: [
                {
                    img: '/responsive/picture/outdoor-recreation/13_1',
                    desc: t('secN_tab1_card1_text'),
                    link: t('secN_tab1_card1_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_2',
                    desc: t('secN_tab1_card2_text'),
                    link: t('secN_tab1_card2_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_3',
                    desc: t('secN_tab1_card3_text'),
                    link: t('secN_tab1_card3_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_4',
                    desc: t('secN_tab1_card4_text'),
                    link: t('secN_tab1_card4_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_5',
                    desc: t('secN_tab1_card5_text'),
                    link: t('secN_tab1_card5_link'),
                },
            ],
            1: [
                {
                    img: '/responsive/picture/outdoor-recreation/13_6',
                    desc: t('secN_tab2_card1_text'),
                    link: t('secN_tab2_card1_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_7',
                    desc: t('secN_tab2_card2_text'),
                    link: t('secN_tab2_card2_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_8',
                    desc: t('secN_tab2_card3_text'),
                    link: t('secN_tab2_card3_link'),
                },
            ],
            2: [
                {
                    img: '/responsive/picture/outdoor-recreation/13_9',
                    desc: t('secN_tab3_card1_text'),
                    link: t('secN_tab3_card1_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_10',
                    desc: t('secN_tab3_card2_text'),
                    link: t('secN_tab3_card2_link'),
                },
            ],
        },
        it: [
            {
                img: '/responsive/picture/outdoor-recreation/13_1',
                desc: t('secN_card1_text'),
                link: t('secN_card1_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_2',
                desc: t('secN_card2_text'),
                link: t('secN_card2_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_3',
                desc: t('secN_card3_text'),
                link: t('secN_card3_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_4',
                desc: t('secN_card4_text'),
                link: t('secN_card4_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_5',
                desc: t('secN_card5_text'),
                link: t('secN_card5_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_6',
                desc: t('secN_card6_text'),
                link: t('secN_card6_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_7',
                desc: t('secN_card7_text'),
                link: t('secN_card7_link'),
            },
        ],
        es: [
            {
                img: '/responsive/picture/outdoor-recreation/13_1',
                desc: t('secN_card1_text'),
                link: t('secN_card1_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_2',
                desc: t('secN_card2_text'),
                link: t('secN_card2_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_3',
                desc: t('secN_card3_text'),
                link: t('secN_card3_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_4',
                desc: t('secN_card4_text'),
                link: t('secN_card4_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_5',
                desc: t('secN_card5_text'),
                link: t('secN_card5_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_6',
                desc: t('secN_card6_text'),
                link: t('secN_card6_link'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/13_7',
                desc: t('secN_card7_text'),
                link: t('secN_card7_link'),
            },
        ],
        au: {
            0: [
                {
                    img: '/responsive/picture/outdoor-recreation/13_1_1',
                    desc: t('secN_tab1_card1_text'),
                    link: t('secN_tab1_card1_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_1_2',
                    desc: t('secN_tab1_card2_text'),
                    link: t('secN_tab1_card2_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_1_3',
                    desc: t('secN_tab1_card3_text'),
                    link: t('secN_tab1_card3_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_1_4',
                    desc: t('secN_tab1_card4_text'),
                    link: t('secN_tab1_card4_link'),
                },
            ],
            1: [
                {
                    img: '/responsive/picture/outdoor-recreation/13_2_1',
                    desc: t('secN_tab2_card1_text'),
                    link: t('secN_tab2_card1_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_2_2',
                    desc: t('secN_tab2_card2_text'),
                    link: t('secN_tab2_card2_link'),
                },
            ],
            2: [
                {
                    img: '/responsive/picture/outdoor-recreation/13_3_1',
                    desc: t('secN_tab3_card1_text'),
                    link: t('secN_tab3_card1_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_3_2',
                    desc: t('secN_tab3_card2_text'),
                    link: t('secN_tab3_card2_link'),
                },
            ],
            3: [
                {
                    img: '/responsive/picture/outdoor-recreation/13_4_1',
                    desc: t('secN_tab4_card1_text'),
                    link: t('secN_tab4_card1_link'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/13_4_2',
                    desc: t('secN_tab4_card2_text'),
                    link: t('secN_tab4_card2_link'),
                },
            ],
        },
    };
    const [items, setItems] = useState(
        Array.isArray(lists[locale] || lists.us) ? lists[locale] || lists.us : lists[locale] ? lists[locale][active] : lists.us[active],
    );

    useEffect(() => {
        setItems(Array.isArray(lists[locale] || lists.us) ? lists[locale] || lists.us : lists[locale] ? lists[locale][active] : lists.us[active]);
    }, [active, locale]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
            window.addEventListener('resize', resetGap);
            return () => window.removeEventListener('resize', resetGap);
        }
    }, []);

    const renderSwiper = useMemo(() => {
        return (
            <Swiper
                className={`swiper-box swiper-box-${active}`}
                effect="fade"
                modules={[Scrollbar, Navigation]}
                navigation={true}
                spaceBetween={gap}
                slidesPerView={'auto'}
                initialSlide={0}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 32,
                    snapOnRelease: true,
                }}
            >
                {items?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        {['us', 'ca'].includes(locale) ? (
                            <EFPicture
                                className="card-img"
                                src={`${card?.img}`}
                                srcDesktop={`${card?.img}`}
                                srcPad={`${card?.img}`}
                                srcMobile={`${card?.img}`}
                                alt={card.desc}
                            />
                        ) : (
                            <EFPicture
                                className="card-img"
                                src={`${card?.img}${LOCAL_SITES.includes(locale) ? `_${locale}` : EU_SITES.includes(locale) ? `_de` : ''}.jpg`}
                                srcDesktop={`${card?.img}_1366${LOCAL_SITES.includes(locale) ? `_${locale}` : EU_SITES.includes(locale) ? `_de` : ''}.jpg`}
                                srcPad={`${card?.img}_375${LOCAL_SITES.includes(locale) ? `_${locale}` : EU_SITES.includes(locale) ? `_de` : ''}.jpg`}
                                srcMobile={`${card?.img}_375${LOCAL_SITES.includes(locale) ? `_${locale}` : EU_SITES.includes(locale) ? `_de` : ''}.jpg`}
                                alt={card.desc}
                            />
                        )}
                        <p className="card-desc">{card?.desc}</p>
                        <Link className="card-link" href={card?.link}>
                            <span className="link-text">{t('common_card_more')}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                <path
                                    d="M6.50006 12.3291L10.5001 8.3291L6.50006 4.3291"
                                    stroke="#2673FF"
                                    strokeWidth="1.33333"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </Link>
                    </SwiperSlide>
                ))}
            </Swiper>
        );
    }, [active, items, gap, locale]);

    return (
        <div id="outdoor-recreation-N" className={`outdoor-recreation-N ${css['outdoor-recreation-N']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secN_title')}</p>
                    <ul className="tabs">
                        {tabs?.map((tab: string, k: number) => (
                            <li className={`tab ${active === k ? 'active' : ''}`} key={k} onClick={() => setActive(k)}>
                                {tab}
                            </li>
                        ))}
                    </ul>
                </div>
                {renderSwiper}
            </div>
        </div>
    );
}
